// @ts-ignore
const dummyPost={title:"Dummy Post",body:"<p>Dummy Post Body</p>",excerpt:"Dummy Post Excerpt",withId:a=>({...dummyPost,id:a})};export{dummyPost};